/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Settings = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 6C12.5 6.53043 12.7107 7.03914 13.0858 7.41421C13.4609 7.78929 13.9696 8 14.5 8C15.0304 8 15.5391 7.78929 15.9142 7.41421C16.2893 7.03914 16.5 6.53043 16.5 6M12.5 6C12.5 5.46957 12.7107 4.96086 13.0858 4.58579C13.4609 4.21071 13.9696 4 14.5 4C15.0304 4 15.5391 4.21071 15.9142 4.58579C16.2893 4.96086 16.5 5.46957 16.5 6M12.5 6H4.5M16.5 6H20.5M6.5 12C6.5 12.5304 6.71071 13.0391 7.08579 13.4142C7.46086 13.7893 7.96957 14 8.5 14C9.03043 14 9.53914 13.7893 9.91421 13.4142C10.2893 13.0391 10.5 12.5304 10.5 12M6.5 12C6.5 11.4696 6.71071 10.9609 7.08579 10.5858C7.46086 10.2107 7.96957 10 8.5 10C9.03043 10 9.53914 10.2107 9.91421 10.5858C10.2893 10.9609 10.5 11.4696 10.5 12M6.5 12H4.5M10.5 12H20.5M15.5 18C15.5 18.5304 15.7107 19.0391 16.0858 19.4142C16.4609 19.7893 16.9696 20 17.5 20C18.0304 20 18.5391 19.7893 18.9142 19.4142C19.2893 19.0391 19.5 18.5304 19.5 18M15.5 18C15.5 17.4696 15.7107 16.9609 16.0858 16.5858C16.4609 16.2107 16.9696 16 17.5 16C18.0304 16 18.5391 16.2107 18.9142 16.5858C19.2893 16.9609 19.5 17.4696 19.5 18M15.5 18H4.5M19.5 18H20.5"
          stroke="#002967"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3978_8918)">
        <path
          d="M8 2.75C8 3.21413 8.18437 3.65925 8.51256 3.98744C8.84075 4.31563 9.28587 4.5 9.75 4.5C10.2141 4.5 10.6592 4.31563 10.9874 3.98744C11.3156 3.65925 11.5 3.21413 11.5 2.75M8 2.75C8 2.28587 8.18437 1.84075 8.51256 1.51256C8.84075 1.18437 9.28587 1 9.75 1C10.2141 1 10.6592 1.18437 10.9874 1.51256C11.3156 1.84075 11.5 2.28587 11.5 2.75M8 2.75H1M11.5 2.75H15M2.75 8C2.75 8.46413 2.93437 8.90925 3.26256 9.23744C3.59075 9.56563 4.03587 9.75 4.5 9.75C4.96413 9.75 5.40925 9.56563 5.73744 9.23744C6.06563 8.90925 6.25 8.46413 6.25 8M2.75 8C2.75 7.53587 2.93437 7.09075 3.26256 6.76256C3.59075 6.43438 4.03587 6.25 4.5 6.25C4.96413 6.25 5.40925 6.43438 5.73744 6.76256C6.06563 7.09075 6.25 7.53587 6.25 8M2.75 8H1M6.25 8H15M10.625 13.25C10.625 13.7141 10.8094 14.1592 11.1376 14.4874C11.4658 14.8156 11.9109 15 12.375 15C12.8391 15 13.2842 14.8156 13.6124 14.4874C13.9406 14.1592 14.125 13.7141 14.125 13.25M10.625 13.25C10.625 12.7859 10.8094 12.3408 11.1376 12.0126C11.4658 11.6844 11.9109 11.5 12.375 11.5C12.8391 11.5 13.2842 11.6844 13.6124 12.0126C13.9406 12.3408 14.125 12.7859 14.125 13.25M10.625 13.25H1M14.125 13.25H15"
          stroke="#002967"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3978_8918">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Settings;
